<ng-container *transloco="let t">
  <div style="display: flex; justify-content: center">
    <mat-card class="lab-card">
      <div class="lab-header">
        <h2 class="title">
          {{ t('Results Biochemical Blood Analysis (Cat) Title') }}
        </h2>
      </div>

      <div class="lab-table" [formGroup]="form">
        <div class="row">
          <div class="param">{{ t('Total Proteins') }}</div>
          <div class="result">
            <input
              matInput
              class="result-input"
              formControlName="totalProteins"
            />
          </div>
          <div class="ref">{{ t('Ref_Total Proteins Cat') }}</div>
        </div>

        <div class="row">
          <div class="param">{{ t('Urea') }}</div>
          <div class="result">
            <input matInput class="result-input" formControlName="urea" />
          </div>
          <div class="ref">{{ t('Ref_Urea Cat') }}</div>
        </div>

        <div class="row">
          <div class="param">{{ t('Creatinine') }}</div>
          <div class="result">
            <input matInput class="result-input" formControlName="creatinine" />
          </div>
          <div class="ref">{{ t('Ref_Creatinine Cat') }}</div>
        </div>

        <div class="row">
          <div class="param">{{ t('Glucose') }}</div>
          <div class="result">
            <input matInput class="result-input" formControlName="glucose" />
          </div>
          <div class="ref">{{ t('Ref_Glucose Cat') }}</div>
        </div>

        <div class="row">
          <div class="param">{{ t('ALT') }}</div>
          <div class="result">
            <input matInput class="result-input" formControlName="alt" />
          </div>
          <div class="ref">{{ t('Ref_ALT Cat') }}</div>
        </div>

        <div class="row">
          <div class="param">{{ t('ALP') }}</div>
          <div class="result">
            <input matInput class="result-input" formControlName="alp" />
          </div>
          <div class="ref">{{ t('Ref_ALP Cat') }}</div>
        </div>

        <div class="row" style="margin-top: 8px">
          <div class="param">{{ t('Veterinarian name and surname') }}</div>
          <div class="result" style="grid-column: span 2">
            <input
              matInput
              class="result-input"
              formControlName="veterinarianName"
            />
          @if (form.get('veterinarianName')?.invalid && form.get('veterinarianName')?.touched) {
            <div class="mat-error" style="font-size:12px;color:#f44336">{{ t('This field is required') }}</div>
          }
          </div>
        </div>
      </div>
    </mat-card>
  </div>
</ng-container>
